module.exports = __webpack_public_path__ + "img/car_shina2_23.dea0c5bb.jpg";